// extracted by mini-css-extract-plugin
export default {"dualSlider":"DualSlider_dualSlider__wGvrm","slider":"DualSlider_slider__HOdkl","sliderMin":"DualSlider_sliderMin__aw4Gw","dualSlider__labels":"DualSlider_dualSlider__labels__Drynt"};